import {
    Button,
    Form,
    Input,
    message,
    Select,
    Skeleton
} from "antd";
import * as AUTH_SERVICES from "api/services/auth/auth.services";
import { FC, useEffect, useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import * as TEACHER_SERVICES from "../../../api/services/teacher/teacher.services";
import * as TOPICS_SERVICES from "../../../api/services/topics/topics.services";

//!IMAGES
import questionPicture from '../../../assets/images/app/question.png';
import TeacherPicture from "../../../assets/images/teacher/teacher.svg";

//!STYLES
import {
    removeDuplicates,
    StatusCode,
} from "common/enums";
import MAA from "components/maa";
import { useDispatch, useSelector } from "react-redux";
import { updateUser } from "store/auth/authSlice";
import stl from "./assets/register.module.css";
import st from "./assets/stepTwo.module.css";

const { Option } = Select;

type Props = {
    stepSixData: any;
    setCurrent: React.Dispatch<React.SetStateAction<number>>;
};

const StepSeven: FC<Props> = ({ stepSixData, setCurrent }) => {
    //!HOOKS
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const [form] = Form.useForm();

    //!STATES
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [tempTopic, setTempTopic] = useState<any>([]);

    const refAddCreneau = useRef<any>();
    const refAddMatiere = useRef<any>();
    const [userNivMat, setUserNivMat] = useState(
        user?.nivMat
            ? user.nivMat
            : [{}]
    );

    const [open, setOpen] = useState<boolean>(false);

    const [profilePreview, setProfilePreview] = useState('');

    const [levels, setLevels] = useState<any>([]);
    const [loadingLevels, setLoadingLevels] = useState<boolean>(false);
    const [selectedData, setSelectedData] = useState<{ [key: string]: any[] }>({});

    const [courses, setCourses] = useState<any>([]);
    const [loadingCourses, setLoadingCourses] = useState<boolean>(false);
    const [selectedCourse, setSelectedCourse] = useState<any>([]);

    const [prices, setPrices] = useState<any>([]);

    const [dataLoaded, setDataLoaded] = useState<boolean>(false);

    const [coursesByGroup, setCoursesByGroup] = useState<any>({});
    const [loadingCoursesGroup, setLoadingCoursesGroup] = useState<any>({});

    const [selectedLevelCourse, setSelectedLevelCourse] = useState<{ levelGroup: string; matiere: string[] }[]>([]);

    //!CONSTANTS
    const validateMessages = {
        required: t("auth.error.required"),
        types: {
            email: t("auth.error.emailInvalid"),
        },
    };

    //!STATES JOFREY
    const [stepSevenData, setStepSevenData] = useState<any>({});

    //!FUNCTIONS JOFREY
    const moveToStepEight = async (values: any) => {

        setIsLoading(true);

        try {
            const response = await TEACHER_SERVICES.addLevelsCourses(user?._id, selectedData, selectedLevelCourse, prices);
            if (response?.statusCode === StatusCode.CREATED) {
                updateUserData();
                message.success({
                    content: "Modification effectuée ",
                });
            }
            else {
                message.warning({
                    content: "une erreur est survenue",
                });
            }
        } catch (error: any) {
            let content = "";
            for (
                let index = 0;
                index < error?.response?.data?.message?.length;
                index++
            ) {
                content = error?.response?.data?.message[index] + ", " + content;
            }
            message.error({
                content: content,
            });
        }
    }

    const updateUserData = async () => {
        try {
            const finalUser = await AUTH_SERVICES.getUserByUid(user.uid);
            if (finalUser?.data) {
                dispatch(updateUser(finalUser.data));
                setIsLoading(false);
                setCurrent(8);
            } else {
                throw new Error("L'utilisateur n'existe pas");
            }
        } catch (error) { }
    }

    const handleGroupClick = (group: string) => {
        setSelectedData((prev: any) => {
            // Toggle selection: If group is already selected, remove it; otherwise, add it
            if (prev[group]) {
                const { [group]: _, ...rest } = prev;
                return rest;
            }
            return { ...prev, [group]: levels[group] };
        });
    };

    const handleLevelCourseClick = (group: string, course: string) => {
        setSelectedLevelCourse((prev) => {
            const groupIndex = prev.findIndex(item => item.levelGroup === group);

            // If the group already exists in the state
            if (groupIndex !== -1) {
                const groupData = prev[groupIndex];
                const isAlreadySelected = groupData.matiere.includes(course);

                const updatedMatiere = isAlreadySelected
                    ? groupData.matiere.filter(id => id !== course) // remove course
                    : [...groupData.matiere, course]; // add course

                const updatedGroup = { ...groupData, matiere: updatedMatiere };
                const newState = [...prev];
                newState[groupIndex] = updatedGroup;
                return newState;
            } else {
                // Group not yet added
                return [...prev, { levelGroup: group, matiere: [course] }];
            }
        });
    };

    const handlePrices = (level: string, value: string | number) => {
        setPrices((prevPrices: any[]) => {
            const updatedPrices = [...prevPrices];
            const existingIndex = updatedPrices.findIndex((p) => p.level === level);
            if (existingIndex !== -1) {
                // Update the existing price
                updatedPrices[existingIndex].price = value;
            } else {
                // Add a new entry
                updatedPrices.push({ levelGroup: level, price: value });
            }
            return updatedPrices;
        });
    };

    const fetchLevels = async () => {
        try {
            setLoadingLevels(true);
            const response = await TOPICS_SERVICES.fetchLevels();
            if (response) {
                const structuredData = Object.keys(response.data).reduce((acc, key) => {
                    acc[key] = response.data[key] ?? [];
                    return acc;
                }, {} as Record<string, any[]>);

                setLevels(structuredData);
            }
        } catch (error) { }
        finally {
            setLoadingLevels(false);
        }
    }

    const fetchLevelCourses = async (group: any) => {
        try {
            setLoadingCoursesGroup((prev: any) => ({ ...prev, [group]: true }));
            const response = await TOPICS_SERVICES.fetchLevelCourses(group);
            if (response) {
                setCoursesByGroup((prev: any) => ({ ...prev, [group]: response.data }));
            }
        } catch (error) {
            console.error("Error fetching courses for group", group, error);
        } finally {
            setLoadingCoursesGroup((prev: any) => ({ ...prev, [group]: false }));
        }
    };

    //!EFFECTS
    useEffect(() => {
        if (user) {
            setProfilePreview(user?.profile);
        }
    }, [user]);

    useLayoutEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        fetchLevels();
    }, [user]);

    useEffect(() => {
        if (user?.groupLevels.length !== 0) {
            const uniqueData = removeDuplicates(user?.groupLevels);
            uniqueData.forEach((groupData: any) => {
                handleGroupClick(groupData?.levelGroup);
            });
        }
    }, [user, levels]);

    useEffect(() => {
        if (user?.matieres?.length && levels && courses) {
            user.matieres.forEach((groupEntry: any) => {
                const group = groupEntry.levelGroup;
                groupEntry.matiere.forEach((courseTitle: any) => {
                    handleLevelCourseClick(group, courseTitle);
                });
            });
            setDataLoaded(true);
        }
    }, [levels, courses]);

    useEffect(() => {
        if (dataLoaded && user?.groupLevels.length !== 0 && user?.matieres.length !== 0) {
            user?.groupLevels.forEach((groupData: any) => {
                handlePrices(groupData?.levelGroup, groupData?.price);
            });
        }
    }, [dataLoaded]);

    useEffect(() => {
        if (dataLoaded && user?.groupLevels.length !== 0 && user?.matieres.length !== 0 && prices) {
            prices.forEach((data: any) => {
                form.setFieldsValue({
                    [`price${data.levelGroup}`]: data.price || 0,
                });
            });
        }
    }, [user, dataLoaded, prices, form, selectedLevelCourse]);

    useEffect(() => {
        if (Object.keys(selectedData).length === 0) {
            setCourses([]);
        }
        else {
            Object.keys(selectedData).forEach(group => {
                fetchLevelCourses(group);
            });
        }
    }, [selectedData]);

    return (
        <section>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "100%", height: "100%", textAlign: "center" }}>
                <div className={st.avatarBox}>
                    {profilePreview !== "" ? <img src={profilePreview} alt="Uploaded Preview" height={140} style={{ borderRadius: "50%" }}></img> : <img src={TeacherPicture} height={140}></img>}
                </div>
                <p className={stl.pageTitle}>Définis tes tarifs</p>
                <p className={st.descriptionTitle}>Indique tes tarifs pour permettre à tes élèves de choisir facilement les options qui leur conviennent.</p>

                <div className={stl.explanationBox} onClick={() => setOpen(!open)}>
                    <img src={questionPicture} alt="Question Mark" height={25} className={stl.questionMark} />
                    <a className={stl.explanationBoxTitle}> Explication du système du points</a>
                </div>

                <div className={stl.levelsBox}>
                    <span>Je donne des cours en : </span>
                    {loadingLevels ? <Skeleton></Skeleton> : <div className={stl.levelsButtons}>
                        {Object.keys(levels).map((group) => (
                            <button
                                key={group}
                                onClick={() => handleGroupClick(group)}
                                className={`${selectedData[group] ? stl.levelButtonActive : stl.levelButton}`}
                            >
                                {group}
                            </button>
                        ))}
                    </div>}
                </div>

                {loadingLevels ? <Skeleton></Skeleton> : Object.keys(selectedData).map((group: any) => (
                    <div className={stl.levelsBox} key={group}>
                        <span>Pour le {group} j’enseigne : </span>
                        {loadingCoursesGroup[group] ? (
                            <Skeleton active />
                        ) : (
                            <div className={stl.topicButtons}>
                                {coursesByGroup[group]?.map((course: any) => {
                                    const groupCourses = selectedLevelCourse.find(item => item.levelGroup === group)?.matiere || [];
                                    const isSelected = groupCourses.includes(course.title);

                                    return (
                                        <button
                                            key={course._id}
                                            onClick={() => handleLevelCourseClick(group, course.title)}
                                            className={isSelected ? stl.topicButtonActive : stl.topicButton}
                                        >
                                            {course.title}
                                        </button>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                ))}

                {Object.keys(selectedData).length !== 0 && selectedLevelCourse.length !== 0 && <div className={stl.pricesBox}>
                    <span>Mes tarifs horaires sont : </span>
                    <div className={stl.priceBox}>
                        {Object.keys(selectedData).map((level) => {
                            return (<div className={stl.price}>
                                <div className={stl.priceLevel}>{level}</div>
                                <Form form={form}>
                                    <Form.Item
                                        name={`price${level}`}
                                        rules={[
                                            { required: true, message: "Ce champ est obligatoire." },
                                        ]}
                                        style={{ marginLeft: "20px" }}
                                    >
                                        <Input
                                            className={stl.field}
                                            placeholder="30"
                                            suffix={"€/Heure"}
                                            type="number"
                                            min={0}
                                            onBlur={(e) => handlePrices(level, e.target.value)}
                                        />
                                    </Form.Item>
                                </Form>
                            </div>);
                        })}
                    </div>
                </div>}

                <div className={stl.rowButtons}>
                    <Button onClick={() => setCurrent((n) => n - 1)} className={stl.newMoveButton}>Retour</Button>
                    <Form.Item style={{ margin: 0, padding: 0 }}>
                        <Button loading={isLoading} htmlType="submit" className={stl.newMoveButton} onClick={moveToStepEight}>Suivant</Button>
                    </Form.Item>
                </div>
            </div>
            <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignContent: "center", justifyItems: "center", alignItems: "center" }}>
                <MAA open={open} setOpen={setOpen} />
            </div>
        </section>
    );
};

export default StepSeven;
